<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#000000',
    },
  }
}
</script>

<template>
  <div>
    <svg :fill="fill" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 31.876 31.876"
      xml:space="preserve">
      <g>
        <g>
          <rect x="19.094" y="11.936" width="2.596" height="0.931" />
          <circle cx="3.667" cy="20.634" r="1.486" />
          <circle cx="7.011" cy="22.946" r="1.486" />
          <circle cx="10.949" cy="24.321" r="1.486" />
          <circle cx="15.105" cy="24.728" r="1.486" />
          <circle cx="19.292" cy="24.259" r="1.486" />
          <circle cx="22.824" cy="22.509" r="1.486" />
          <circle cx="25.824" cy="20.009" r="1.486" />
          <circle cx="1.607" cy="25.19" r="1.607" />
          <circle cx="5.339" cy="27.632" r="1.607" />
          <circle cx="9.687" cy="29.114" r="1.606" />
          <circle cx="14.436" cy="29.542" r="1.606" />
          <circle cx="19.17" cy="29.22" r="1.607" />
          <circle cx="23.464" cy="27.688" r="1.607" />
          <circle cx="27.096" cy="25.327" r="1.606" />
          <circle cx="30.27" cy="22.223" r="1.606" />
          <path d="M15.263,22.276c6.525,0,9.111-3.301,10.014-5.013v-0.583c-0.598,1.392-2.916,5.346-10.014,5.346
			c-8.583,0-11.442-4.617-11.471-4.664l-0.015,0.01v0.404C4.56,18.8,7.77,22.276,15.263,22.276z" />
          <path d="M14.975,26.983c7.938,0,11.817-4.41,12.896-5.889v-0.434c-0.65,0.983-4.42,6.071-12.896,6.071
			c-9.079,0-12.894-4.688-13.135-4.998v0.384C2.773,23.163,6.753,26.983,14.975,26.983z" />
          <circle cx="14.03" cy="9.751" r="1.786" />
          <path d="M12.414,14.789l0.033,0.666h0.094v0.406v0.3l0.385,1.961h-0.361v0.563h1.364v-0.563H13.82v-0.201v-0.079v-1.681h0.449
			v1.681v0.079v0.183h-0.152v0.562h1.427v-0.562h-0.376l0.38-1.942v-0.3v-0.406h0.113l0.091-1.494h7.495V3.938h-5.229l-2.002-2.001
			c0.074-0.122,0.121-0.263,0.121-0.417c0-0.438-0.356-0.793-0.792-0.793c-0.438,0-0.792,0.355-0.792,0.793
			c0,0.132,0.035,0.255,0.092,0.364L12.59,3.938H5.78v10.021h6.557L12.414,14.789z M14.849,2.136
			c0.136,0.109,0.307,0.177,0.495,0.177c0.167,0,0.322-0.053,0.45-0.141l1.767,1.767h-4.514L14.849,2.136z M6.425,13.314V4.583
			h16.177v8.731h-6.811l0.036-0.589l3.582-1.597l-0.405-0.78l-2.72,1.336l-1.604,0.124L14,12.598l-0.659-0.79l-1.099,0.143
			l-3.012-1.48l-0.422,0.86l3.443,1.692l0.027,0.292H6.425z" />
        </g>
      </g>
    </svg>
  </div>
</template>
